module.exports = __webpack_public_path__ + "img/bonusmq.e586c43c.png";